/* lib/adapters/restaurant.js — `restaurantReal`: профиль + реквизиты ресторана поверх боевого клиента.
 * Ключи бэка ↔ UI: default_allergens_to_avoid↔guest_allergens, default_allergens_critical↔guest_allergens_critical,
 * default_menu_categories↔menu_categories, notes↔technologist_notes. `format` — ENUM (slug + format_choices[] →
 * Select в UI). brand_voice — free text. Реквизиты (legal_name/inn/...) — отдельный эндпоинт /workspace/requisites/. */

import { unwrap } from '../api/unwrap.js';
import * as api from '../api/restaurant.js';

function fromApiProfile(p) {
  return {
    photo_url: p.photo_url || null,
    concept: p.concept || '',
    format: p.format || '',
    format_choices: p.format_choices || [],     // [{value,label}] для Select
    avg_check_rub: p.avg_check_rub,
    location: p.location || '',
    cuisine_types: p.cuisine_types || [],
    target_audience: p.target_audience || '',
    brand_voice: p.brand_voice || '',
    guest_allergens: p.default_allergens_to_avoid || [],
    guest_allergens_critical: p.default_allergens_critical || [],
    menu_categories: p.default_menu_categories || [],
    technologist_notes: p.notes || '',
  };
}

function toApiProfile(form) {
  return {
    concept: form.concept || '',
    format: form.format || '',                  // slug из format_choices (free text → 400)
    avg_check_rub: form.avg_check_rub == null || form.avg_check_rub === '' ? null : Number(form.avg_check_rub),
    location: form.location || '',
    cuisine_types: form.cuisine_types || [],
    target_audience: form.target_audience || '',
    brand_voice: form.brand_voice || '',
    default_allergens_to_avoid: form.guest_allergens || [],
    default_allergens_critical: form.guest_allergens_critical || [],
    default_menu_categories: form.menu_categories || [],
    notes: form.technologist_notes || '',
  };
}

async function getProfile(workspaceId) {
  return fromApiProfile(await unwrap(api.getProfile(workspaceId)));
}

async function updateProfile(form, workspaceId) {
  return fromApiProfile(await unwrap(api.updateProfile(toApiProfile(form), workspaceId)));
}

// Фото/логотип: бэк возвращает обновлённый профиль (с photo_url) — отдаём его адаптированным.
async function uploadProfilePhoto(file, workspaceId) {
  return fromApiProfile(await unwrap(api.uploadProfilePhoto(file, workspaceId)));
}

async function deleteProfilePhoto(workspaceId) {
  return fromApiProfile(await unwrap(api.deleteProfilePhoto(workspaceId)));
}

// Реквизиты: ключи бэка == ключи UI (все строки), адаптация не нужна — passthrough.
async function getRequisites(workspaceId) {
  return unwrap(api.getRequisites(workspaceId));
}

async function updateRequisites(form, workspaceId) {
  return unwrap(api.updateRequisites(form || {}, workspaceId));
}

export const restaurantReal = {
  getProfile, updateProfile, uploadProfilePhoto, deleteProfilePhoto,
  getRequisites, updateRequisites,
};
